import Vue from "vue";
import configs from "../configs";
import queryString from "query-string";

const ip = configs.apiBase;

const contribuicoesNotasFaltantes = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contribuicoes/empresa/${
      query.idEmpresa
    }/faltantes?${queryString.stringify(query)}`,
  );
};

const contribuicoesInserirNotasFaltantes = (query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/contribuicoes/faltantes/`,
    query,
  );
};

const contribuicoesNotasInseridas = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contribuicoes/faltantes/inseridas?${queryString.stringify(query)}`,
  );
};

const contribuicoesProdutos = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contribuicoes/faltantes/inseridas/produtos?${queryString.stringify(
      query,
    )}`,
  );
};

const contribuicoesUpdateProdutos = (query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/contribuicoes/faltantes/inseridas/produtos`,
    query,
  );
};

const contribuicoesCorrigirPisCofins = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contribuicoes/piscofins/corrigir?${queryString.stringify(query)}`,
  );
};

const getXmlFaltantes = (query) => {
  // idEmpresa=283&dtIni=2019-01-01&dtFin=2019-03-31&codMod=55&tipo=terceiros
  return Vue.prototype.$http.get(
    `${ip}/auditoria/erro/xml/faltante?${queryString.stringify(query)}`,
  );
};

/**
 * Busca as XML faltantes de saída
 * @param {Object} query
 * @param {string} query.dtFin
 * @param {string} query.dtIni
 * @param {number} query.idEmpresa
 * @param {number} query.codMod
 */
const getXmlFaltantesSaida = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/erro/xml/faltante/saida?${queryString.stringify(query)}`,
  );
};

/**
 * Busca as XML faltantes de entrada
 * @param {Object} query
 * @param {string} query.dtFin
 * @param {string} query.dtIni
 * @param {number} query.idEmpresa
 * @param {number} query.codMod
 */
const getXmlFaltantesEntrada = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/erro/xml/faltante/entrada?${queryString.stringify(query)}`,
  );
};

const importMissingXmls = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/erro/xml/faltante/import?${queryString.stringify(query)}`,
  );
};

const notasRecusadas = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/terceiros/erro/recusada?${queryString.stringify(
      query,
      {
        arrayFormat: "bracket",
      },
    )}`,
  );
};

// idEmpresa=169&dtIni=2019-08-01&dtFin=2019-08-30```
const naoLancadas = (query) =>
  Vue.prototype.$http.get(
    `${ip}/auditoria/terceiros/erro/naolancada?${queryString.stringify(query)}`,
  );

const getXmlFaltantesSped = (query) => {
  // idEmpresa=286&dtInicial=2019-03-01&dtFinal=2019-03-31
  return Vue.prototype.$http.get(
    `${ip}/auditoria/terceiros/xml/faltante/sped?${queryString.stringify(query)}`,
  );
};

// ESTOQUE CONTABILIDADE
const estoqueContabilidade = (query) => {
  // idEmpresa=12&vigencia=2019-09-01
  return Vue.prototype.$http.get(
    `${ip}/auditoria/estoque/contabilidade?${queryString.stringify(query)}`,
  );
};

// ESTOQUE SPED
const estoqueSped = (query) => {
  // idEmpresa=12&dtInicial=2019-09-01&dtFinal=2019-09-30&percentual=10
  return Vue.prototype.$http.get(
    `${ip}/auditoria/estoque/sped?${queryString.stringify(query)}`,
  );
};

// CFOP

const getItemsSped = (params) => {
  // empresa/12/efd/itens?idRegC100=316521893&idNfe=108113955
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/empresa/${params.idCompany}/efd/itens?${queryString.stringify(
      params.query,
    )}`,
  );
};

const updateItemsSped = (params) => {
  // regC170?idRegC100=&idReg0000=
  return Vue.prototype.$http.put(
    `${ip}/auditoria/cfop/regC170?${queryString.stringify(params.query)}`,
    params.items,
  );
};

const getAccounts = (query) => {
  // contas?idRegC100=&pesquisa=
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/contas?${queryString.stringify(query)}`,
  );
};

const referenceCta = (params) => {
  // contabil/resumo
  return Vue.prototype.$http.post(
    `${ip}/auditoria/contabil/resumo`,
    params,
  );
};

const removeCta = (query) => {
  // auditoria/contabil/resumo?idEmpresa=&cpfCnpj=&operacao=&codItem=&codcta=
  return Vue.prototype.$http.delete(
    `${ip}/auditoria/contabil/resumo?${queryString.stringify(query)}`,
  );
};

const getProducts = (params) => {
  // empresa/:idEmpresa/produtos?idReg0000=79732&vigencia=2021-04-01&codItem=&pesquisa=box'
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/empresa/${params.idCompany}/produtos?${queryString.stringify(
      params.query,
    )}`,
  );
};

const removeProduct = (query) => {
  // regC170?idReg0000=&idRegC100=&idRegC170=
  return Vue.prototype.$http.delete(
    `${ip}/auditoria/cfop/regC170?${queryString.stringify(query)}`,
  );
};

const getTotalizerSped = (query) => {
  // contabil/resumo/nota/efd?idRegC100=
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/resumo/nota/efd?${queryString.stringify(query)}`,
  );
};

const updateRegC190 = (payload) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/regC190`,
    payload,
  );
};

const getTotalizerNfe = (query) => {
  // contabil/resumo/nota/efd?idRegC100=
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/resumo/nfe?${queryString.stringify(query)}`,
  );
};

const getCfopList = () => {
  return Vue.prototype.$http.get(`${ip}/auditoria/cfop/lista`);
};

const getTotalNfeRef = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/resumo/contas/ref?${queryString.stringify(query)}`,
  );
};

const getTotalizerByOperation = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/totalizador?${queryString.stringify(query)}`,
  );
};

const fixRegC190 = (query) => {
  return Vue.prototype.$http.put(
    `${ip}/auditoria/cfop/regC190?${queryString.stringify(query)}`,
  );
};

const getXmlFaltantesCfop = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/xml/faltante?${queryString.stringify(query)}`,
  );
};

const getApuracaoIrpjCsllSimulacao = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/apuracao/irpj/simulacao?${queryString.stringify(query)}`,
  );
};

const insertApuracaoIrpjCsll = (query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/contabil/apuracao/irpj?${queryString.stringify(query)}`,
  );
};

const insertApuracaoIrpjCsllParcelas = (query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/contabil/apuracao/irpj/parcelas?${queryString.stringify(query)}`,
  );
};

const getApuracaoSudam = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/apuracao/irpj/sudam?${queryString.stringify(query)}`,
  );
};

const getApuracaoReal = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/apuracao/irpj/real?${queryString.stringify(query)}`,
  );
};

const getApuracaoPresumido = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/contabil/apuracao/irpj/presumido?${queryString.stringify(query)}`,
  );
};

const getConsultaNfeDados = (query) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/nfe/dados?${queryString.stringify(query)}`,
  );
};

const deleteNfeKey = (query) => {
  return Vue.prototype.$http.delete(
    `${ip}/auditoria/cfop/nfe?${queryString.stringify(query)}`,
  );
};

const fix0150CfopPage = (idReg0000) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/fix/0150/${idReg0000}`,
  );
};

const transferNotesCfopPage = (idReg0000) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/transfer/${idReg0000}`,
  );
};

const insertTransferNotesCfopPage = (idReg0000) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/cfop/transfer/${idReg0000}`,
  );
};

const fixNotesNoMovIcmsCfopPage = (idReg0000) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/fix/noicms/${idReg0000}`,
  );
};

const fixNotesMovIcmsCfopPage = (idReg0000) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/fix/movicms/${idReg0000}`,
  );
};

const getDivergenceNotesCfopPage = (idReg0000) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/divergences/${idReg0000}`,
  );
};

const getNotesCfopPage = ({ idReg0000, movIcms }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/notes/${idReg0000}?movIcms=${movIcms}`,
  );
};

const getNotesToSTApuration = ({ idEmpresa, dtInicial, sped }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/icmsst/notes?idEmpresa=${idEmpresa}&dtInicial=${dtInicial}&sped=${sped}`,
  );
};

const getItensXMLNotesSTApuration = (idNfe, aliqIcms) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/icmsst/xml/itens?idNfe=${idNfe}&aliqIcms=${aliqIcms}`,
  );
};

const getItensSPEDNotesSTApuration = (idReg0000, idRegC100) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/icmsst/sped/itens?idReg0000=${idReg0000}&idRegC100=${idRegC100}`,
  );
};

const insertReferenceService = (data) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/icmsst/reference/itens`,
    data,
  );
};

const deleteReferenceService = ({ cpfCnpj, cProd, xProd, idEmpresa }) => {
  const encodedCProd = encodeURIComponent(cProd);
  const encodedXProd = encodeURIComponent(xProd);
  return Vue.prototype.$http.delete(
    `${ip}/auditoria/icmsst/reference?cpfCnpj=${cpfCnpj}&cProd=${encodedCProd}&xProd=${encodedXProd}&idEmpresa=${idEmpresa}`,
  );
};

const getCalcIcmsSt = ({
  cpfCnpj,
  cProd,
  xProd,
  cest,
  credOutorgado,
  vlItem,
  vlBcIcms,
  aliqIcms,
  vlIcms,
  qtd,
  idEmpresa,
  idNfe,
}) => {
  const encodedCProd = encodeURIComponent(cProd);
  const encodedXProd = encodeURIComponent(xProd);
  return Vue.prototype.$http.get(
    `${ip}/auditoria/icmsst/calc?cpfCnpj=${cpfCnpj}&cProd=${encodedCProd}&xProd=${encodedXProd}&cest=${cest}&credOutorgado=${credOutorgado}&vlItem=${vlItem}&vlBcIcms=${vlBcIcms}&aliqIcms=${aliqIcms}&vlIcms=${vlIcms}&qtd=${qtd}&idEmpresa=${idEmpresa}&idNfe=${idNfe}`,
  );
};

const insertStApured = (data) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/icmsst/save/valuest`,
    data,
  );
};

const fixc170CfopPage = (idRegC100) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/fix/c170/${idRegC100}`,
  );
};

const getErrorsOnNoteCfopPage = (idRegC100) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/errors/note/${idRegC100}`,
  );
};

const getItemsXmlCfopPage = ({ idNfe, queryOperations }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/cfop/xml/items/${idNfe}${queryOperations}`,
  );
};

const fixc190CfopPage = (idRegC100) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/fix/c190/${idRegC100}`,
  );
};

const updateNcmNfe = (params) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/update/ncm/nfe`,
    params,
  );
};

const updateNcmSped = (params) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/update/ncm/sped`,
    params,
  );
};
const updateNcmCadastro = (params) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/cfop/update/ncm/cadastro`,
    params,
  );
};

const notesRefContabilPage = (idReg0000) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/refcontabil/notes/${idReg0000}`,
  );
};

const divergencesRefContabilPage = (idReg0000) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/refcontabil/divergences/${idReg0000}`,
  );
};

const getTotalAccountRefContabilPage = (idReg0000) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/refcontabil/total/${idReg0000}`,
  );
};

const getComprasFuturasRefContabilPage = (idReg0000) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/refcontabil/compras/futuras/${idReg0000}`,
  );
};

const generateUnreleasedReportPdf = (body, query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/terceiros/generate/pdf?${queryString.stringify(query)}`,
    body,
  );
};

const utilitiesReportPdf = (body) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/relatorios/generate/pdf`,
    body,
  );
};

const stReportPdf = (body) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/apuracaoIcmsSt/generate/pdf`,
    body,
  );
};

const relatorioAuditoriaNotasExcluidas = ({ idEmpresa, dtIni }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/relatorio/efdIcmsIpi/notasExcluidas?idEmpresa=${idEmpresa}&dtIni=${dtIni}`,
  );
};

const calcDiffAliquot = ({
  idEmpresa,
  cpfCnpj,
  cProd,
  xProd,
  idProd,
  vlLiquido,
  vlBcIcms,
  aliqIcms,
  vlIcms,
  vlSt,
  aliqOrigem,
  aliqDestino,
  aliqDifal,
  idNfe,
}) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/calculo/diferencial/aliquota?${queryString.stringify(
      {
        idEmpresa,
        cpfCnpj,
        cProd,
        xProd,
        idProd,
        vlLiquido,
        vlBcIcms,
        aliqIcms,
        vlIcms,
        vlSt,
        aliqOrigem,
        aliqDestino,
        aliqDifal,
        idNfe,
      },
    )}`,
  );
};

const resetVlIcmsItem = (payload) => {
  return Vue.prototype.$http.patch(
    `${ip}/auditoria/reset/vl/icms/item`,
    payload,
  );
};

const generateAliquotDifferentialPdf = (body, query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/aliquot/differential/generate/pdf?${queryString.stringify(query)}`,
    body,
  );
};

const getAnalyticalMovementCfop = (body) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/analitico/cfop`,
    body,
  );
};

const generateNotesPerSeriePdf = (body, query) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/generate/notes/per/serie/pdf?${queryString.stringify(query)}`,
    body,
  );
};

const retrieveConvenio = (ncmCestDesc) => {
  const query = queryString.stringify({ ncmCestDesc });
  return Vue.prototype.$http.get(
    `${ip}/auditoria/produtos/ricms/convenio/ncm?${query}`,
  );
};

const referenceConvenio = ({
  idEmpresa,
  cpfCnpj,
  cProd,
  xProd,
  anexo,
  item,
}) => {
  const payload = { idEmpresa, cpfCnpj, cProd, xProd, anexo, item };
  return Vue.prototype.$http.post(
    `${ip}/auditoria/reference/convenio`,
    payload,
  );
};

const removeReferenceConvenio = ({ idEmpresa, cpfCnpj, cProd, xProd }) => {
  return Vue.prototype.$http.delete(
    `${ip}/delete/reference/convenio?idEmpresa=${idEmpresa}&cpfCnpj=${cpfCnpj}&cProd=${cProd}&xProd=${xProd}`,
  );
};

const UploadEcfFile = (formData) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/ecf/import`,
    formData,
  );
};

const getEcfDetails = ({ idEmpresa, dtIni, dtFin, registerType }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/ecf/${registerType}/details?idEmpresa=${idEmpresa}&dtIni=${dtIni}&dtFin=${dtFin}`,
  );
};

const getRecibos = ({ cpfCnpj, dataInicial, dataFinal }) => {
  return Vue.prototype.$http.get(
    `${ip}/auditoria/recibos?cpfCnpj=${cpfCnpj}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
  );
};

const importRecibos = (formData) => {
  return Vue.prototype.$http.post(
    `${ip}/auditoria/importar/recibo`,
    formData,
  );
};

const removeRecibo = ({ cpfCnpj, dataInicial, dataTransmitido }) => {
  return Vue.prototype.$http.delete(
    `${ip}/auditoria/delete/recibo?cpfCnpj=${cpfCnpj}&dataInicial=${dataInicial}&dataTransmitido=${dataTransmitido}`,
  );
};

const getNotesCfopPageNew = ({ idReg0000 }) => {
  return Vue.prototype.$http.get(`${ip}/auditoria/notificacoes/cfop/notes/${idReg0000}`)
}

const retrieveItemsXml = ({ idNfe }) => {
  return Vue.prototype.$http.get(`${ip}/auditoria/notificacoes/itens/xml?idNfe=${idNfe}`)
}

const retrieveItemsSped = ({ idRegC100, idNfe }) => {
  return Vue.prototype.$http.get(`${ip}/auditoria/notificacoes/itens/sped?idRegC100=${idRegC100}&idNfe=${idNfe}`)
}

const updateItemNumber = ({ spedsReadyToSave }) => {
  return Vue.prototype.$http.patch(`${ip}/auditoria/notificacoes/update/numero/item`, spedsReadyToSave)
}

const importF100 = (payload) => {
  return Vue.prototype.$http.post(`${ip}/auditoria/inserir/f100`, payload)
}

const importF120 = (payload) => {
  return Vue.prototype.$http.post(`${ip}/auditoria/inserir/f120`, payload)
}

const generateMaiorMenorNumNfceReport = (payload, query) => {
  return Vue.prototype.$http.post(`${ip}/auditoria/generate/maior/menor/num/nfce/pdf?${queryString.stringify(query)}`, payload)
}

export default {
  stReportPdf,
  utilitiesReportPdf,
  relatorioAuditoriaNotasExcluidas,
  updateNcmNfe,
  updateNcmSped,
  updateNcmCadastro,
  getTotalAccountRefContabilPage,
  getComprasFuturasRefContabilPage,
  notesRefContabilPage,
  divergencesRefContabilPage,
  fixc190CfopPage,
  fixc170CfopPage,
  getErrorsOnNoteCfopPage,
  getItemsXmlCfopPage,
  deleteNfeKey,
  removeCta,
  getAccounts,
  referenceCta,
  getXmlFaltantesCfop,
  getConsultaNfeDados,
  removeProduct,
  fixRegC190,
  getTotalizerSped,
  getTotalNfeRef,
  getTotalizerNfe,
  getApuracaoIrpjCsllSimulacao,
  getCfopList,
  getProducts,
  estoqueSped,
  naoLancadas,
  getItemsSped,
  notasRecusadas,
  updateItemsSped,
  getXmlFaltantes,
  getXmlFaltantesSped,
  getXmlFaltantesSaida,
  getTotalizerByOperation,
  estoqueContabilidade,
  contribuicoesProdutos,
  getXmlFaltantesEntrada,
  contribuicoesNotasInseridas,
  contribuicoesUpdateProdutos,
  contribuicoesNotasFaltantes,
  contribuicoesCorrigirPisCofins,
  contribuicoesInserirNotasFaltantes,
  insertApuracaoIrpjCsll,
  insertApuracaoIrpjCsllParcelas,
  getApuracaoSudam,
  getApuracaoReal,
  getApuracaoPresumido,
  importMissingXmls,
  fix0150CfopPage,
  transferNotesCfopPage,
  insertTransferNotesCfopPage,
  fixNotesNoMovIcmsCfopPage,
  fixNotesMovIcmsCfopPage,
  getDivergenceNotesCfopPage,
  getNotesCfopPage,
  updateRegC190,
  generateUnreleasedReportPdf,
  getNotesToSTApuration,
  getItensSPEDNotesSTApuration,
  getItensXMLNotesSTApuration,
  insertReferenceService,
  deleteReferenceService,
  getCalcIcmsSt,
  insertStApured,
  calcDiffAliquot,
  resetVlIcmsItem,
  generateAliquotDifferentialPdf,
  getAnalyticalMovementCfop,
  generateNotesPerSeriePdf,
  retrieveConvenio,
  referenceConvenio,
  removeReferenceConvenio,
  UploadEcfFile,
  getEcfDetails,
  getRecibos,
  importRecibos,
  removeRecibo,
  getNotesCfopPageNew,
  retrieveItemsXml,
  retrieveItemsSped,
  updateItemNumber,
  importF100,
  importF120,
  generateMaiorMenorNumNfceReport
}
